import { Text } from '@mantine/core';

import type { MoneyDisplayViewProps } from './MoneyDisplay.types';

export function formatMoney(
  amount: number,
  { currency = 'DKK', maximumFractionDigits = 0 }: { currency?: string; maximumFractionDigits?: number } = {}
) {
  return new Intl.NumberFormat('da-DK', { style: 'currency', currency, maximumFractionDigits }).format(
    amount
  );
}

export function MoneyDisplayView({
  amount,
  currency = 'DKK',
  maximumFractionDigits = 0,
  fallback = '–',
  colorizeSign = false,
  fw,
  size = 'sm',
}: MoneyDisplayViewProps) {
  if (amount == null) {
    return (
      <Text size={size} c="dimmed" span>
        {fallback}
      </Text>
    );
  }

  const color = colorizeSign ? (amount > 0 ? 'teal.7' : amount < 0 ? 'red.7' : undefined) : undefined;

  return (
    <Text size={size} fw={fw} c={color} span>
      {formatMoney(amount, { currency, maximumFractionDigits })}
    </Text>
  );
}
